import React from "react";
import { IconButtonProps } from "@origin-digital/ods-core";
import { SearchFieldProps } from "src/components/Form/SearchField/types";
import { useFeedContext } from "src/context/Feed";

export const useSearchAction = () => {
  const { searchInput, setSearchInput } = useFeedContext();
  const [searchFieldShown, setSearchFieldShown] = React.useState(false);

  const searchFieldProps: SearchFieldProps = React.useMemo(() => {
    return {
      searchInput: searchInput || "",
      setSearchInput,
      "data-id": "actionSection.searchField",
    };
  }, [searchInput, setSearchInput]);

  const closeSearchIconButtonProps: Partial<IconButtonProps> =
    React.useMemo(() => {
      return {
        onClick: () => {
          setSearchInput("");
          setSearchFieldShown(false);
        },
        "data-id": "actionSection.closeSearchIconButton",
      };
    }, [setSearchInput, setSearchFieldShown]);

  const openSearchIconButtonProps: Partial<IconButtonProps> =
    React.useMemo(() => {
      return {
        onClick: () => {
          setSearchFieldShown(true);
        },
        "data-id": "actionSection.openSearchIconButton",
      };
    }, [setSearchFieldShown]);

  return {
    searchFieldProps,
    closeSearchIconButtonProps,
    openSearchIconButtonProps,
    searchFieldShown,
  };
};
